import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { getBreaks } from "@/Services/TherapyApi/Breaks";
import BreakTransformer, { type BreakTransformerType } from "@/Modules/Transformers/Break";

import usePatientsStore from "@/Modules/Patients/Store";
import useAppStore from "@/Modules/App/Store";
import useChatStore from "@/Modules/Chat/Store";

import { hasValue } from "@/Utils/Objects";
import { unixUTC } from "@/Utils/Date";
import { isValidString } from "@/Utils/String";

async function reloadCurrentBreakActionHandler(roomId: string): Promise<void> {
  const patientsStore = usePatientsStore();
  const appStore = useAppStore();
  const chatStore = useChatStore();

  patientsStore.isLoading = true;

  try {
    if (hasValue(chatStore.rooms[roomId])) {
      const { user } = chatStore.rooms[roomId];
      const unixTime = unixUTC();

      if (isValidString(user.customerUuid)) {
        const breaks = await getBreaks(user.customerUuid);
        const currentBreak = breaks.find((b) => b.created_at < unixTime && b.end_at > unixTime);

        const breakTransformer: BreakTransformerType = BreakTransformer;

        chatStore.rooms[roomId].currentBreak = hasValue(currentBreak)
          ? breakTransformer.toDomain(currentBreak)
          : undefined;
      }
    }
  } catch (error: unknown) {
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });
  } finally {
    patientsStore.isLoading = false;
  }
}

export default reloadCurrentBreakActionHandler;
